export default "__VITE_ASSET__d34f9f08__"